/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PaymentIntentsPaymentIntent model module.
 * @module model/PaymentIntentsPaymentIntent
 * @version v0.3
 */
export default class PaymentIntentsPaymentIntent {
  /**
   * Constructs a new <code>PaymentIntentsPaymentIntent</code>.
   * @alias module:model/PaymentIntentsPaymentIntent
   * @class
   * @param orderId {String} ID of the order this payment intent is for
   */
  constructor(orderId) {
    this.orderId = orderId;
  }

  /**
   * Constructs a <code>PaymentIntentsPaymentIntent</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PaymentIntentsPaymentIntent} obj Optional instance to populate.
   * @return {module:model/PaymentIntentsPaymentIntent} The populated <code>PaymentIntentsPaymentIntent</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PaymentIntentsPaymentIntent();
      if (data.hasOwnProperty('order_id'))
        obj.orderId = ApiClient.convertToType(data['order_id'], 'String');
    }
    return obj;
  }
}

/**
 * ID of the order this payment intent is for
 * @member {String} orderId
 */
PaymentIntentsPaymentIntent.prototype.orderId = undefined;

